export const TableOfContentsStyles= {
    HIDDEN: "879148bc-c407-4928-801b-b400f9115231",
    SHOWABOVE: "26273466-d5fa-4042-8410-d8eed1a3215c",
    SHOWBELOW: "a0486924-d0a5-45d0-ad94-291d33d02095"
}